import View from '@ckeditor/ckeditor5-ui/src/view'

export default class CustomLinkPopup extends View {

	constructor(linkAddress, linkText, linkTypeId, selection, isEdit, locale) {
		super( locale );

        this.linkAddress = linkAddress;
        this.linkText = linkText;
        this.id = linkTypeId;
        this.selection = selection;

		const bind = this.bindTemplate;

        let popupControls = [];

        let popUpControlsData = {
            tag: 'a',
            attributes: {
                class: [
                    'ck', 
                    'ck-button',
                    'ck-off',
                    'ck-button_with-text',
                    'ck-link-actions__preview'
                ],             
                target:"_blank"
            },
            children: [
                {
                    tag: 'span',
                    attributes: {
                        class: [
                            'ck', 
                            'ck-button__label',
                            'ck-off',
                            'ck-button_with-text',
                            'ck-link-actions__preview'
                        ]
                    },
                    children: [
                        {
                            text: linkAddress
                        }
                    ]
                },
            ]
        }

        if(linkTypeId !== 'linktoanotherdocument') {
            popUpControlsData.attributes['href'] = linkAddress;
        } else {
            popUpControlsData.on = {
                click: bind.to('routeToLink')
            }
        }
        popupControls.push(popUpControlsData);

        if(isEdit){
            popupControls.push({
                tag: 'button',
                attributes: {
                    class: [
                        'ck',
                        'ck-button',
                        'deleteLinkButton',
                        'wk-button',
                        'wk-button-text',
                        'ck-off',
                        'ck-button_with-text'
                    ]
                },
                children:[
                    {
                        tag: 'span',
                        attributes: {
                            class: [
                                'ck',
                                'ck-button__label'
                            ]
                        },
                    },
                    {
                        text: 'Delete link'
                    }
                ],
                on: {

                    click: bind.to('deleteLink')
                }
            });

            popupControls.push({
                tag: 'button',
                attributes: {
                    class: [
                        'ck',
                        'ck-button',
                        'editLinkButton ',
                        'wk-button',
                        'wk-button-text',
                        'ck-off',
                        'ck-button_with-text'
                    ]
                },
                children:[
                    {
                        tag: 'span',
                        attributes: {
                            class: [
                                'ck',
                                'ck-button__label'
                            ]
                        },
                    },
                    {
                        text: 'Edit link'
                    }
                ],
                on: {

                    click: bind.to('editLink')
                }
            });
        }

		this.setTemplate( {
			tag: 'div',
			attributes: {
				class: [
					'ck-balloon-rotator__content'
				]
			},
            children: [
                {
                    tag: 'div',
                    attributes:{
                        class: [
                            'ck', 
                            'ck-link-actions ck-responsive-form'
                        ]
                    },
                    children: popupControls
                }
            ]
		});
	}
}